// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card[data-v-6c02e576] {\n  width: 150px;\n  height: 60px;\n  border-radius: 35px !important;\n  padding-left: 20px;\n  padding-right: 20px;\n}\n@media (min-width: 640px) {\n.card[data-v-6c02e576] {\n    min-width: 170px;\n    height: 70px;\n    padding-left: 31px;\n    padding-right: 31px;\n}\n}", ""]);
// Exports
module.exports = exports;
